var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditEdition = function SvgEditEdition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "edit-edition",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.929,
    height: 36.929
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4353",
    cx: 18.464,
    cy: 18.464,
    r: 18.464
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-edit-2",
    d: "M23.081 9.217a2.568 2.568 0 1 1 3.631 3.631l-12.255 12.26-4.993 1.357 1.362-4.993Z",
    fill: "none",
    "data-fill": "a"
  })));
};
export default SvgEditEdition;